// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const CoolerFanMobileContent = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  display: flex;
  width: 100%;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  border-top: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  > p {
    font-size: 13px;
  };
`;

export const CoolerFanStatusContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  display: none;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  border-top: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  border-left: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  /* ******* TABLET (SM - 576px and up) ******* */
  @media (min-width: ${BREAKPOINTS.sm}px) {
    display: flex;
    padding: 1rem 1.5rem;
    margin-right: 1px;
  };

  /* ******* EXTRA LARGE DESKTOP (XL - 1200px and up) ******* */
  @media (min-width: ${BREAKPOINTS.xl}px) {
    margin-right: 0;
  };
`;

export const LubePressureStatusContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  width: 100%;
  flex: none;
  padding: 0.5rem 0 1rem;

  /* ******* TABLET (SM - 576px and up) ******* */
  @media (min-width: ${BREAKPOINTS.sm}px) {
    height: 100%;
    flex: 1;
    width: auto;
    padding: 0;
  };
`;

export const LubricationContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  height: 100%;
  flex-direction: column;
  border-radius: 4px;
  display: flex;
`;

export const LubricationContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const MainContentRow = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  display: flex;
  flex: 1;
  flex-direction: column;

  /* ******* TABLET (SM - 576px and up) ******* */
  @media (min-width: ${BREAKPOINTS.sm}px) {
    flex-direction: row;
  };
`;

export const OverallStatusContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  width: 100%;
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  border-top: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  border-right: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  > p {
    font-size: 13px;
  };

  /* ******* TABLET (SM - 576px and up) ******* */
  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;

    > p {
      font-size: inherit;
    };
  };
`;

export const StatusContainer = styled.div`
  display: flex;
`;

export const ThermometersContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  display: flex;
  height: auto;
  flex: 1;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0;

  /* ******* TABLET (SM - 576px and up) ******* */
  @media (min-width: ${BREAKPOINTS.sm}px) {
    height: 100%;
    flex: 0 0 66.666%;
    width: auto;
    justify-content: center;
    padding: 0.5rem 1rem;
    border-right: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  };

  /* ******* LARGE DESKTOP (LG - 992px and up) ******* */
  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding: 1.25rem;
  };

  /* ******* EXTRA LARGE DESKTOP (XL - 1200px and up) ******* */
  @media (min-width: ${BREAKPOINTS.xl}px) {
    padding: 0;
  };
`;

export const WinterModeStatusContainer = styled.div`
  /* Mobile First - Base styles for smallest devices (XS) */
  width: 100%;
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  border-top: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  > p {
    font-size: 13px;
  };

  /* ******* TABLET (SM - 576px and up) ******* */
  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;

    > p {
      font-size: inherit;
    };
  };
`;
